import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { name: "Landing", path: "/", component: () => import("./pages/LandingPage.vue") },
  { name: "UseTerms", path: "/terms-of-use", component: () => import("./pages/UseTermsPage.vue") },
  { name: "PrivacyTerms", path: "/terms-of-privacy", component: () => import("./pages/PrivacyTermsPage.vue") },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ el: to.hash, behavior: 'smooth' })
        }, 300)
      })
    }
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

export { router }
